// extracted by mini-css-extract-plugin
export default {"equal":"equal__sxw5m"};